/** @jsxImportSource @emotion/react */
import { PlusOutlined } from "@ant-design/icons";
import { css } from "@emotion/react";
import { Button, Form, Input, Table } from "antd";
import _ from "lodash";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import ServiceCreate from "src/containers/aiPlatform/userService/components/ServiceCreate";
import ServiceEdit from "src/containers/aiPlatform/userService/components/ServiceEdit";
// import ServiceCreate from "src/containers/aiPlatform/service/components/ServiceCreate";
import { useFormatMessage } from "src/hooks";
import messageIds from "src/locales/messageIds";
import { AppServiceManage } from "src/models/aiPlatform";
import { AiServiceClient } from "src/services/AIPlatformService";

export default React.memo(function UserServiceManagement() {
  const formatMessage = useFormatMessage();

  const [isCreateShow, setIsCreateShow] = useState(false);
  const [isEditShow, setIsEditShow] = useState(false);
  const [editDetail, setEditDetail] = useState({} as AppServiceManage);
  const [dataSource, setDataSource] = useState([] as AppServiceManage[]);
  const [name, setName] = useState("");
  const [email] = useState("");
  const [phone] = useState("");
  const [loading, setLoading] = useState(false);

  // const onTableChange = useCallback(
  //   (pagination) => {
  //     setPagiation(pagination);
  //   },
  //   [setPagiation]
  // );

  const onCreate = useCallback(() => {
    setIsCreateShow(!isCreateShow);
  }, [isCreateShow]);

  const onEdit = useCallback(
    (record: AppServiceManage) => {
      setIsEditShow(true);
      setEditDetail(record);
    },
    [setIsEditShow, setEditDetail]
  );

  const onEditCancel = useCallback(() => {
    setIsEditShow(false);
  }, [setIsEditShow]);

  // const menu = useCallback(
  //   (record) => (
  //     <Menu>
  //       <Menu.Item
  //         key="view"
  //         css={css`
  //           font-size: 12px;
  //           :hover {
  //             color: rgb(51, 119, 255);
  //             border-radius: 4px;
  //             cursor: pointer;
  //             background: rgb(51, 119, 255, 0.1);
  //           }
  //         `}
  //         onClick={() => onEdit(record)}
  //       >
  //         {formatMessage(messageIds.common.detail)}
  //       </Menu.Item>
  //     </Menu>
  //   ),
  //   [formatMessage, onEdit]
  // );

  const columns = [
    {
      title: formatMessage(messageIds.aiManage.userManagment.ssoIdentityUid),
      dataIndex: "ownerId",
      ellipsis: true,
    },
    {
      title: formatMessage(messageIds.common.name),
      dataIndex: "name",
      ellipsis: true,
    },
    {
      title: formatMessage(messageIds.common.createTime),
      dataIndex: "createDatetime",
      ellipsis: true,
      render: (text: string, record: AppServiceManage) =>
        moment(text).utcOffset(-480).format("YYYY-MM-DD HH:mm:ss"),
    },
    // {
    //   title: formatMessage(
    //     messageIds.aiManage.userServiceManagement.editService.keyOne
    //   ),
    //   dataIndex: "appMasterSecret",
    //   ellipsis: true,
    //   // width: "20%",
    // },
    // {
    //   title: formatMessage(
    //     messageIds.aiManage.userServiceManagement.editService.keyTwo
    //   ),
    //   dataIndex: "appSecondSecret",
    //   ellipsis: true,
    //   // width: "20%",
    // },
    {
      title: formatMessage(messageIds.common.operation),
      dataIndex: "operation",
      width: 80,
      render: (text: string, record: AppServiceManage) => (
        <Button
          css={css`
            padding: 4px 0px;
          `}
          type="link"
          onClick={() => onEdit(record)}
        >
          {formatMessage(messageIds.common.detail)}{" "}
        </Button>
        // <Dropdown
        //   overlay={menu(record)}
        //   placement="bottomLeft"
        //   css={css`
        //     display: flex;
        //     align-items: center;
        //     justify-content: center;
        //     width: 30px;
        //     height: 30px;
        //     :hover {
        //       color: rgb(51, 119, 255);
        //       border-radius: 4px;
        //       cursor: pointer;
        //       background: rgb(51, 119, 255, 0.1);
        //     }
        //   `}
        // >
        //   <MoreOutlined />
        // </Dropdown>
      ),
    },
  ];

  const fetch = useCallback((name?: string, email?: string, phone?: string) => {
    setLoading(true);
    AiServiceClient.getAppServiceList(
      _.trim(name),
      _.trim(email),
      _.trim(phone)
    ).then((res) => {
      setDataSource(res?.data?.data);
      setLoading(false);
    });
  }, []);

  const onSearch = useCallback(() => {
    fetch(name, email, phone);
  }, [fetch, name, email, phone]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return (
    <div
      css={css`
        flex-grow: 1;
        padding: 30px;
      `}
    >
      <div
        css={css`
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          margin-right: 30px;
          padding-bottom: 30px;
        `}
      >
        <div
          css={css`
            max-width: 1000px;
            margin-right: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          `}
        >
          <h1
            css={css`
              position: relative;
              margin: 0px 0px 8px;
              padding-left: 10px;
              line-height: 18px;
              font-size: 18px;
              font-weight: 600;
              color: rgb(61, 73, 102);
              ::before {
                content: "";
                position: absolute;
                left: 0px;
                width: 3px;
                height: 18px;
                background: rgb(51, 119, 255);
              }
            `}
          >
            {formatMessage(messageIds.aiManage.userServiceManagement.name)}
          </h1>
        </div>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          css={css`
            padding: 4px 20px;
            border-radius: 4;
            background-color: rgb(51, 119, 255);
          `}
          onClick={onCreate}
        >
          {formatMessage(messageIds.common.create)}
        </Button>
      </div>

      <div
        css={css`
          display: flex;
          padding-bottom: 24px;
          border-bottom: 1px solid rgb(202, 209, 224);
        `}
      >
        <Form layout="inline">
          <Form.Item label={`${formatMessage(messageIds.common.name)} : `}>
            <Input
              placeholder={formatMessage(
                messageIds.aiManage.userServiceManagement.common.inputName
              )}
              onChange={(e) => setName(e.target.value)}
              allowClear
            ></Input>
          </Form.Item>
          {/* <Form.Item label={`${formatMessage(messageIds.common.email)} : `}>
            <Input
              placeholder={formatMessage(
                messageIds.aiManage.userServiceManagement.common.inputEmail
              )}
              onChange={(e) => setEmail(e.target.value)}
              allowClear
            ></Input>
          </Form.Item>
          <Form.Item label={`${formatMessage(messageIds.common.phone)} : `}>
            <Input
              placeholder={formatMessage(
                messageIds.aiManage.userServiceManagement.common.inputPhone
              )}
              onChange={(e) => setPhone(e.target.value)}
              allowClear
            ></Input>
          </Form.Item> */}
          <Form.Item>
            <Button type="primary" onClick={onSearch}>
              {formatMessage(messageIds.common.select)}
            </Button>
          </Form.Item>
        </Form>
      </div>
      <div
        css={css`
          margin-top: 30px;
        `}
      >
        <Table
          columns={columns}
          dataSource={dataSource}
          rowKey={(record) => record?.id}
          // onChange={(pagination) => onTableChange(pagination)}
          // pagination={{ ...pagination, showSizeChanger: false }}
          loading={loading}
        ></Table>
      </div>
      <ServiceCreate
        isCreateShow={isCreateShow}
        onCreate={onCreate}
        fetch={fetch}
      ></ServiceCreate>
      <ServiceEdit
        isEditShow={isEditShow}
        editDetail={editDetail}
        onEditCancel={onEditCancel}
        fetch={onSearch}
      ></ServiceEdit>
    </div>
  );
});
